import React from 'react';
import './DashboardFooter.scss'
import { ChallengeButton } from '../../../../common';

const DashboardFooter = ({firstButtonTitle, secondButtonTitle, onFirstBtnClick, onSecondBtnClick, eventType = true, selfDashboard}) => {
    return (
        <div className='team-dashboard-footer-container'>
           <ChallengeButton btnTitle={firstButtonTitle} secBtn={selfDashboard ? true : false} onBtnClick={() => onFirstBtnClick()}/>
           {eventType && <ChallengeButton btnTitle={secondButtonTitle} successBtn={true} onBtnClick={() => onSecondBtnClick()}/>}
        </div>
    )
}

export default DashboardFooter